export default {
  login () {
    window.sessionStorage.setItem('huix-freight-admin-login', true)
  },
  setUser (user) {
    window.sessionStorage.setItem('huix-freight-admin-user', JSON.stringify(user))
  },
  getUser () {
    const user = window.sessionStorage.getItem('huix-freight-admin-user')
    return user ? JSON.parse(user) : null
  },
  logout () {
    window.sessionStorage.removeItem('huix-freight-admin-login')
    window.sessionStorage.removeItem('huix-freight-admin-user')
    window.sessionStorage.removeItem('token')
  },
  isLogin () {
    const loginResult = window.sessionStorage.getItem('huix-freight-admin-login')
    return loginResult || false
  }
}
